export default "__VITE_ASSET__001d47a6__"